import React, { useState, useEffect } from "react";
import './all.css';
import axios from "axios";
import { DelBtn } from "../button/Button";

const mainurl = process.env.REACT_APP_MURL ||"http://localhost:1729";
// const mainurl = "http://localhost:1729";
const url = `${mainurl}/loveres`;

const AllResults = () => {
    console.log(url);
    const [loveResults, setLoveResults] = useState([]);

    const fetchAllResults = async () => {
        const response = await fetch(url);
        const data = await response.json();
        setLoveResults(data);
    };

    const delet = (id) => {
        axios.delete(`${mainurl}/del/${id}`)
            .then(() => {
                setLoveResults(prevResults => prevResults.filter(result => result._id !== id));
            })
            .catch(err => console.error(err));
    };

    useEffect(() => {
        fetchAllResults();
    }, []);


    return (
        <div className="love-results">
            <h2>All Relationship Results</h2>
            <table border="1" cellPadding="10" style={{ borderCollapse: "collapse" }}>
                <thead>
                    <tr>
                        <th>S.no</th>
                        <th>Your Name</th>
                        <th>Partner's Name</th>
                        <th>Relationship</th>
                        <th>Percentage</th>
                        <th>Time</th>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    {loveResults.map((result, index) => (
                        <tr key={index}>
                            <td>{index+1}</td>
                            <td>{result.name1}</td>
                            <td>{result.name2}</td>
                            <td>{result.result}</td>
                            <td>{result.percentage}%</td>
                            <td>
                                {result.ctime}
                            </td>
                            <td>
                                <DelBtn onClick={() => delet(result._id)} />
                            </td>

                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default AllResults;
